import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-screen pt-24 pb-16 px-4 flex flex-col items-center justify-center overflow-hidden" data-id="element-105">
      {/* Background effects */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-purple-900/20 via-[#0B0D17] to-[#0B0D17] -z-10" data-id="element-106"></div>
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#39FF14]/10 rounded-full blur-[100px] -z-10" data-id="element-107"></div>

      <div className="max-w-5xl mx-auto text-center z-10" data-id="element-108">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-6" data-id="element-109">
          Cómo <span className="neon-text-green" data-id="element-110">Hackear</span> tus Propios
          Ahorros y Hacer tus Primeras{' '}
          <span className="neon-text-green" data-id="element-111">Inversiones Legales</span> Antes de
          los <span className="neon-text-green" data-id="element-112">18</span> — Sin Tener que Leer
          Manuales de 400 Páginas
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-10" data-id="element-113">
          El sistema visual de 15 minutos diseñado para adolescentes que quieren
          libertad y para padres que quieren dejar de financiar caprichos.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mb-12" data-id="element-114">
          <img src="https://cdn.magicpatterns.com/uploads/dmxtZ3c6R6X2V2gCMJxSvd/Imagen_Principal.png" alt="Dinero Pro en múltiples dispositivos" className="w-full max-w-4xl mx-auto drop-shadow-[0_0_30px_rgba(139,92,246,0.3)]" data-id="element-115" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} data-id="element-116">
          <CTAButton text="SÍ, QUIERO SER UN DINERO PRO — ACCESO INMEDIATO POR $6.39" className="w-full md:w-auto" data-id="element-117" />
        </motion.div>
      </div>
    </section>;
}